import React from 'react';
import { MenuItem } from '@mui/material';
import styles from './ProfessionalProfileTab.module.scss';
import { SelectUi } from '../../../../ui/SelectUi/SelectUi';
import { ProfessionalProfileTabProps } from './types/ProfessionalProfileTab.types';
import { useProfessionalProfileTab } from './hooks/useProfessionalProfileTab';

export const ProfessionalProfileTab: React.FC<ProfessionalProfileTabProps> = (props) => {
    const { editMode, professions, errors, loadingSpecialties } = props;

    const {
        t,
        selectedUid,
        handleProfessionChange,
        getSelectedProfessionName
    } = useProfessionalProfileTab({ ...props, loadingSpecialties });

    return (
        <div className={styles['profile-tab']}>
            <header className={styles['profile-tab__header']}>
                <h3 className={styles['profile-tab__title']}>
                    {t('appAdmin.EditTabsComponent.mainProfessionTabTitle', 'Ahora elegí la actividad principal con la que querés presentarte en Bodhiwell.')}
                </h3>
                <p className={styles['profile-tab__description']}>
                    {t('appAdmin.EditTabsComponent.mainProfessionTabSubtitle', 'La opción que elijas se utilizará para construir tu identidad pública a partir del estudio que la respalda.')}
                </p>
            </header>

            <div className={styles['profile-tab__selector-box']}>
                <SelectUi
                    label={t('appAdmin.EditProfessionalInfo.mainProfession', 'ACTIVIDAD PRINCIPAL')}
                    displayEmpty
                    value={selectedUid}
                    onChange={handleProfessionChange}
                    disabled={!editMode}
                    error={!!errors?.['main_profession']}
                    helperText={errors?.['main_profession']}
                    renderValue={(selected: any) => {
                        if (!selected) {
                            return (
                                <span className={styles['profile-tab__placeholder']}>
                                    {t('appAdmin.EditProfessionalInfo.selectProfession', 'Elegí tu actividad principal')}
                                </span>
                            );
                        }
                        return getSelectedProfessionName(selected);
                    }}
                >
                    <MenuItem disabled value="">
                        <em>{t('appAdmin.EditProfessionalInfo.mainProfession', 'Elegí tu actividad principal')}</em>
                    </MenuItem>

                    {professions && professions.length > 0 ? (
                        professions.map((profession) => (
                            <MenuItem key={profession.uid} value={profession.uid}>
                                {profession.name}
                            </MenuItem>
                        ))
                    ) : (
                        <MenuItem disabled value="none" sx={{ '&.Mui-disabled': { opacity: 1 } }}>
                            <span className={styles['profile-tab__empty-msg']}>
                                {t('appAdmin.EditProfessionalInfo.noEligibleProfessions', 'Asegúrate de agregar una especialidad principal en la pestaña de Estudios.')}
                            </span>
                        </MenuItem>
                    )}
                </SelectUi>
            </div>

            <div className={styles['profile-tab__note']}>
                <span className={styles['profile-tab__note-icon']}>i</span>
                <p>{t('appAdmin.EditTabsComponent.mainProfessionNote', 'Solo podés elegir entre las actividades respaldadas por los estudios que hayas cargado.')}</p>
            </div>
        </div>
    );
};